<script setup lang="ts" generic="T extends object = Record<string, unknown>">
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';
  import type { TreeItemEmits, TreeItemProps } from 'reka-ui';
  import { reactiveOmit } from '@vueuse/core';
  import { TreeItem as RekaTreeItem, useForwardPropsEmits } from 'reka-ui';
  import { cn } from '@/shared/lib/utils';

  const props = defineProps<
    TreeItemProps<T> & {
      indent?: number;
      class?: HTMLAttributes['class'];
    }
  >();

  const emits = defineEmits<TreeItemEmits<T>>();

  const delegatedProps = reactiveOmit(props, 'indent', 'class');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);

  const paddingLeft = computed(() => {
    const step = props.indent ?? 20;
    return `${props.level * step}px`;
  });
</script>

<template>
  <RekaTreeItem
    data-slot="tree-item"
    :value="props.value"
    :level="props.level"
    v-bind="forwarded"
    :class="cn('outline-none', props.class)"
    :style="{ paddingLeft }"
    @select.prevent
    @toggle.prevent
  >
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </RekaTreeItem>
</template>
